import alertIcon from './alert-icon.svg';
import completeIcon from './complete-icon.svg';
import deloitteLogo from './deloitte_logo.png';
import docsIcon from './docs-icon.svg';
import documentStoreIcon from './document-store-icon.svg';
import downloadGreyIcon from './download-icon-grey.svg';
import downloadWhiteIcon from './download-icon-white.svg';
import downloadIcon from './download-icon.svg';
import errorIcon from './error-icon.svg';
import extractedIcon from './extracted-icon.svg';
import filterIcon from './filter-icon.svg';
import filter from './filter.svg';
import gridViewIcon from './grid-view-icon.svg';
import loginBackground from './login-background.jpg';
import logoutIcon from './logout-icon.svg';
import originalIcon from './original-icon.svg';
import plusIcon from './plus-icon.svg';
import profileIcon from './profile-icon.svg';
import questionIcon from './question-icon.svg';
import reviewIcon from './review-icon.svg';
import tableViewIcon from './table-view-icon.svg';
import uploadIcon from './upload-icon.svg';
import warnIcon from './warn-icon.svg';
export const icons = {
    alert: alertIcon,
    complete: completeIcon,
    deloitteLogo,
    docs: docsIcon,
    documentStore: documentStoreIcon,
    downloadGrey: downloadGreyIcon,
    downloadWhite: downloadWhiteIcon,
    download: downloadIcon,
    error: errorIcon,
    extracted: extractedIcon,
    filter: filterIcon,
    filterAlt: filter,
    gridView: gridViewIcon,
    loginBackground,
    logout: logoutIcon,
    original: originalIcon,
    plus: plusIcon,
    profile: profileIcon,
    question: questionIcon,
    review: reviewIcon,
    tableView: tableViewIcon,
    upload: uploadIcon,
    warn: warnIcon,
};
